import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';
import { useStoreData } from '../hooks/useStoreData';

const Footer = () => {
  const { settings } = useStoreData();

  return (
    <footer className="bg-[#4a1a1f] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/rizzahra-43273.firebasestorage.app/o/74e4297d-1681-4176-a129-faaf9c90eaec-removebg-preview.png?alt=media&token=cd033554-61ba-4194-aacf-06fc9f7b4eb0"
                alt={settings?.storeName || "Rizzahra"}
                className="h-16 w-auto object-contain mb-4"
              />
            </div>
            <p className="text-sm text-gray-300 mb-4">
              Crafting elegant modest fashion for generations. Your trusted destination for premium abayas.
            </p>
            <div className="flex gap-4">
              {settings?.socialMedia?.facebook && (
                <a href={settings.socialMedia.facebook} target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a86a] transition-colors">
                  <Facebook size={20} />
                </a>
              )}
              {settings?.socialMedia?.instagram && (
                <a href={settings.socialMedia.instagram} target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a86a] transition-colors">
                  <Instagram size={20} />
                </a>
              )}
              {settings?.socialMedia?.twitter && (
                <a href={settings.socialMedia.twitter} target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a86a] transition-colors">
                  <Twitter size={20} />
                </a>
              )}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 uppercase tracking-wider">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about-us" className="text-gray-300 hover:text-[#c9a86a] transition-colors">About Us</Link></li>
              <li><Link to="/our-story" className="text-gray-300 hover:text-[#c9a86a] transition-colors">Our Story</Link></li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="text-lg font-semibold mb-4 uppercase tracking-wider">Customer Service</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/exchange-policy" className="text-gray-300 hover:text-[#c9a86a] transition-colors">Exchange Policy</Link></li>
              <li><Link to="/faq" className="text-gray-300 hover:text-[#c9a86a] transition-colors">FAQs</Link></li>
              <li><Link to="/privacy-policy" className="text-gray-300 hover:text-[#c9a86a] transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions" className="text-gray-300 hover:text-[#c9a86a] transition-colors">Terms & Conditions</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4 uppercase tracking-wider">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              {settings?.contactInfo?.address && (
                <li className="flex items-start gap-2 text-gray-300">
                  <MapPin size={18} className="mt-1 flex-shrink-0" />
                  <span>{settings.contactInfo.address}</span>
                </li>
              )}
              {settings?.contactInfo?.phone && (
                <li className="flex items-center gap-2 text-gray-300">
                  <Phone size={18} className="flex-shrink-0" />
                  <span>{settings.contactInfo.phone}</span>
                </li>
              )}
              {settings?.contactInfo?.email && (
                <li className="flex items-center gap-2 text-gray-300">
                  <Mail size={18} className="flex-shrink-0" />
                  <span>{settings.contactInfo.email}</span>
                </li>
              )}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#5a2a2f] pt-8 text-center text-sm text-gray-300">
          <p>&copy; {new Date().getFullYear()} {settings?.storeName || 'Abaya Store'}. All rights reserved. Crafted with love for modest fashion.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;